@import "@/ui/variables.css";

.cardGridRoot,
.cardGridRoot > div > ol {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);

  & > *:nth-child(odd) {
    justify-self: end;
  }

  article {
    transform: translateY(0);
    transition: transform 100ms ease-in-out;
  }

  article:hover {
    transform: translateY(-6px);
  }
}

@media (max-width: 780px) {
  .cardGridRoot,
  .cardGridRoot > div > ol,
  .cardGridRoot > div > article {
    grid-template-columns: 1fr;

    & > *:nth-child(odd),
    & > *:nth-child(even) {
      justify-self: center;
    }
  }
}
